import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10% 0px'
  });
  const getInitialPosition = () => {
    switch (direction) {
      case 'up':
        return {
          y: 40,
          opacity: 0
        };
      case 'down':
        return {
          y: -40,
          opacity: 0
        };
      case 'left':
        return {
          x: 40,
          opacity: 0
        };
      case 'right':
        return {
          x: -40,
          opacity: 0
        };
      case 'none':
        return {
          opacity: 0
        };
      default:
        return {
          y: 40,
          opacity: 0
        };
    }
  };
  const getFinalPosition = () => {
    switch (direction) {
      case 'up':
      case 'down':
        return {
          y: 0,
          opacity: 1
        };
      case 'left':
      case 'right':
        return {
          x: 0,
          opacity: 1
        };
      case 'none':
        return {
          opacity: 1
        };
      default:
        return {
          y: 0,
          opacity: 1
        };
    }
  };
  return <motion.div ref={ref} initial={getInitialPosition()} animate={isInView ? getFinalPosition() : getInitialPosition()} transition={{
    duration: 0.8,
    delay: delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-218">
      {children}
    </motion.div>;
}